import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const PendingUsers = () => {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [pendingUsersOriginal, setPendingUsersOriginal] = useState([]);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedDealer, setSelectedDealer] = useState(null);

  const getPendingUsers = () => {
    setLoading(true);
    axios.post(API_URL.USERS_PENDING, {}).then(
      (res) => {
        if (res.data.status === 1) {
          setPendingUsers(res.data.data);
          setPendingUsersOriginal(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
        });
      }
    );
  };

  const getDealers = () => {
    axios.post(API_URL.USERS_LIST, { type: 3 }).then(
      (res) => {
        if (res.data.status === 1) {
          let dealerOptions = res.data.data.data.map((dealer) => ({
            label: dealer.name,
            value: dealer.id,
          }));
          setDealers(dealerOptions);
        }
      },
      (error) => {
        toast.error("Failed to load dealers", {
          autoClose: 3000,
        });
      }
    );
  };

  const openAssignModal = (user) => {
    setSelectedUser(user);
    setSelectedDealer(null);
    setShowAssignModal(true);
  };

  const assignDealer = () => {
    if (!selectedDealer) {
      toast.error("Please select a dealer", { autoClose: 3000 });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: `You want to assign ${selectedUser.name} to ${selectedDealer.label}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, assign!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.USERS_ASSIGN_DEALER, { 
          user_id: selectedUser.id, 
          owner_id: selectedDealer.value 
        }).then(
          (res) => {
            if (res.data.status === 1) {
              // Remove the user from pending list
              let newData = pendingUsers.filter((u) => u.id !== selectedUser.id);
              setPendingUsers(newData);
              setPendingUsersOriginal(newData);
              toast.success(`${selectedUser.name} assigned to dealer successfully`, { 
                autoClose: 3000 
              });
              setShowAssignModal(false);
              setSelectedUser(null);
              setSelectedDealer(null);
            } else {
              toast.error(res.data.message || "Assignment failed", { 
                autoClose: 3000 
              });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { 
              autoClose: 3000 
            });
          }
        );
      }
    });
  };

  const handleSearchChange = async (e) => {
    const value = e.target.value;
    setSearchValue(value);

    if (value.length >= 3) {
      try {
        const res = await axios.post(API_URL.USERS_SEARCH, { text: value });
        
        if (Array.isArray(res.data)) {
          // Filter to only show pending users from search results
          const filteredResults = res.data.filter(user => user.status === 0);
          setPendingUsers(filteredResults);
        } else if (Array.isArray(res.data.data)) {
          const filteredResults = res.data.data.filter(user => user.status === 0);
          setPendingUsers(filteredResults);
        }
      } catch (error) {
        toast.error("Search failed", { autoClose: 2000 });
      }
    } else {
      setPendingUsers(pendingUsersOriginal);
    }
  };

  useEffect(() => {
    getPendingUsers();
    getDealers();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-4">
          <h1>Pending Users <small className="me-2">({pendingUsers.length})</small></h1>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center justify-content-end">
            <div className="col-md-5 mb-0 mr-2">
              <div className="form-group mb-0 mr-2">
                <input
                  type="text"
                  value={searchValue}
                  onChange={handleSearchChange}
                  className="form-control"
                  placeholder="Search by Name ..."
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Contact</th>
                          <th>Location</th>
                          <th>Registration Date</th>
                          <th
                            className="text-center"
                            style={{ width: "150px" }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingUsers.length === 0 ? (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No pending users found
                            </td>
                          </tr>
                        ) : (
                          pendingUsers.map((row, key) => {
                            return (
                              <tr key={key}>
                                <td>{key + 1}</td>
                                <td>{row.name}</td>
                                <td>{row.email}</td>
                                <td>{row.contact_no}</td>
                                <td>{row.city_name}, {row.state_name}</td>
                                <td>{row.created_at ? new Date(row.created_at).toLocaleDateString() : 'N/A'}</td>
                                <td className="d-flex justify-content-center gap-2" style={{ width: "150px" }}>
                                  <button 
                                    onClick={() => openAssignModal(row)} 
                                    className="btn btn-sm btn-primary"
                                  >
                                    <i className="fa fa-user-plus me-1"></i> Assign Dealer
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Assign Dealer Modal */}
      <Modal show={showAssignModal} onHide={() => setShowAssignModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Assign Dealer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedUser && (
            <div>
              <div className="mb-3">
                <strong>User Details:</strong>
                <div className="mt-2">
                  <p><strong>Name:</strong> {selectedUser.name}</p>
                  <p><strong>Email:</strong> {selectedUser.email}</p>
                  <p><strong>Contact:</strong> {selectedUser.contact_no}</p>
                  <p><strong>Location:</strong> {selectedUser.city_name}, {selectedUser.state_name}</p>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label"><strong>Select Dealer:</strong></label>
                <Select
                  options={dealers}
                  value={selectedDealer}
                  onChange={setSelectedDealer}
                  placeholder="Choose a dealer to assign..."
                  isClearable
                  isSearchable
                  className="mt-1"
                />
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAssignModal(false)}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={assignDealer}
            disabled={!selectedDealer || loading}
          >
            {loading ? "Assigning..." : "Assign Dealer"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PendingUsers;
